import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AiTemplateService {

  constructor(private api: ApiService) {}

  generateTemplate(userPrompt: string, type: 'html' | 'text', template_type: 'whatsapp' | 'email'): Observable<{ type: string; content: string }> {
    return this.api.post<{ type: string; content: string }>(environment.getEmailTemplate, {
      userPrompt,
      type,
      template_type
    });
  }

  /**
   * Converts markdown-style formatting from AI responses into HTML.
   * Handles: **bold**, *bold*, _italic_, ~strikethrough~, \n newlines.
   * Note: **double-asterisk** is processed before *single* to avoid conflicts.
   */
  parseMarkdownToHtml(text: string): string {
    if (!text) return '';
    return text
      .replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')   // **bold**
      .replace(/\*(.*?)\*/g, '<b>$1</b>')         // *bold*
      .replace(/_(.*?)_/g, '<em>$1</em>')         // _italic_
      .replace(/~(.*?)~/g, '<s>$1</s>')           // ~strikethrough~
      .replace(/\n/g, '<br>');                     // newlines
  }
}
